<div class="ui-input-container">
  <label [for]="textId" class="ui-input-label"
    >{{ label }}
    @if (required && label) {
      *
    }
  </label>

  @if (hasSuffix) {
    <div class="ui-input-row ui-input-row--with-suffix">
      <input
        #inputElement
        [id]="textId"
        [disabled]="disabled"
        [placeholder]="placeholder"
        [required]="required"
        [type]="type"
        [value]="value"
        (input)="handleInput($event)"
        (blur)="onTouched()"
        [autocomplete]="autocomplete"
        [attr.max]="maxAttr"
        [attr.min]="minAttr"
        [class.ui-input-widget--invalid]="errorMessage"
        [attr.aria-invalid]="errorMessage ? 'true' : null"
        [attr.aria-describedby]="errorMessage ? textId + '-error' : null"
        class="ui-input-widget"
      />
      <span class="ui-input-suffix">
        <ng-content select="[uiInputSuffix]"></ng-content>
      </span>
    </div>
  } @else {
    <input
      #inputElement
      [id]="textId"
      [disabled]="disabled"
      [placeholder]="placeholder"
      [required]="required"
      [type]="type"
      [value]="value"
      (input)="handleInput($event)"
      (blur)="onTouched()"
      [autocomplete]="autocomplete"
      [attr.max]="maxAttr"
      [attr.min]="minAttr"
      [class.ui-input-widget--invalid]="errorMessage"
      [attr.aria-invalid]="errorMessage ? 'true' : null"
      [attr.aria-describedby]="errorMessage ? textId + '-error' : null"
      class="ui-input-widget"
    />
  }

  @if (errorMessage) {
    <p [id]="textId + '-error'" class="ui-input-error" role="alert">{{ errorMessage }}</p>
  }
</div>
